import React from 'react'
import { AuthPageWrapper } from '../styles/Components'
import SignUpSignInForm from '../components/sign-up-sign-in-form'
import ResetPasswordForm from '../components/signin/ResetPasswordForm'
import querystring from 'query-string'
import { useUserContext } from '../components/UserContext'
import { useRouter } from 'next/router'
import _ from 'lodash'
import Head from 'next/head'

const Auth = () => {
  const { user } = useUserContext()

  const router = useRouter()
  // get hash from path string— next cannot interpret # serverside
  const hash = router.asPath.split('#')[1] || ''
  let query

  if (hash) {
    query = hash
      .slice(hash.indexOf('?') + 1)
      .split('&')
      .reduce((a, b) => {
        b = b.split('=')
        a[b[0]] = b[1]
        return a
      }, {})
  } else {
    query = router.query
  }

  // find path to redirect to after login
  let successRedirectPath = query?.onSuccess || '/'
  const remainingQuery = _.omit(query, 'onSuccess')

  // check for additional search properties
  if (Object.keys(remainingQuery).length) {
    successRedirectPath += `&${querystring.stringify(remainingQuery)}`
  }

  // if successRedirectPath is not a valid path, redirect to home
  if (!(/^\/[^\/][^\s?]*(\?[^\s#]*)?(#.*)?$/.test(successRedirectPath))) {
    successRedirectPath = '/'
  }

  // redirect if already authenticated
  if (user?.id) {
    router.push(successRedirectPath)
    return null
  }

  // parse hash and check if we've received a password reset token or key 
  const passwordResetToken = query.token || query.key

  if (passwordResetToken) {
    return (
      <ResetPasswordForm
        history={router}
        data-testid="reset-password-form"
        token={decodeURIComponent(passwordResetToken)}
        isProvider={!!query.key} // when true we pass a key in the request body instead of a token
      />
    )
  }

  return (
    <AuthPageWrapper>
      <Head>
        <title>Glamsquad</title>
      </Head>      
      <SignUpSignInForm
        id="auth-forms"
        showHeadlines={true}
        initSignUpForm={false}
        onSuccess={() => {
          router.push(successRedirectPath)
        }}
      />
    </AuthPageWrapper>
  )
}

export default Auth
